import "./main.css";
import {useStyleProps as $6WzO6$useStyleProps, classNames as $6WzO6$classNames, useDOMRef as $6WzO6$useDOMRef} from "@react-spectrum/utils";
import {Flex as $6WzO6$Flex} from "@react-spectrum/layout";
import {mergeProps as $6WzO6$mergeProps, mergeRefs as $6WzO6$mergeRefs, filterDOMProps as $6WzO6$filterDOMProps} from "@react-aria/utils";
import $6WzO6$react, {useCallback as $6WzO6$useCallback} from "react";
import {useFormProps as $6WzO6$useFormProps} from "@react-spectrum/form";
import $6WzO6$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import $6WzO6$spectrumiconsuiAsterisk from "@spectrum-icons/ui/Asterisk";
import {useLocalizedStringFormatter as $6WzO6$useLocalizedStringFormatter} from "@react-aria/i18n";
import {useProviderProps as $6WzO6$useProviderProps} from "@react-spectrum/provider";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}





var $beda4304297005df$exports = {};

$parcel$export($beda4304297005df$exports, "spectrum-HelpText", () => $beda4304297005df$export$c0875e83c57c7736, (v) => $beda4304297005df$export$c0875e83c57c7736 = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText-validationIcon", () => $beda4304297005df$export$527776642b333691, (v) => $beda4304297005df$export$527776642b333691 = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText-text", () => $beda4304297005df$export$a512452beb4231bf, (v) => $beda4304297005df$export$a512452beb4231bf = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText--neutral", () => $beda4304297005df$export$6e9351b1ad13c, (v) => $beda4304297005df$export$6e9351b1ad13c = v);
$parcel$export($beda4304297005df$exports, "is-disabled", () => $beda4304297005df$export$d35bc1e505d1ebbf, (v) => $beda4304297005df$export$d35bc1e505d1ebbf = v);
$parcel$export($beda4304297005df$exports, "spectrum-HelpText--negative", () => $beda4304297005df$export$d31dd875d69daee0, (v) => $beda4304297005df$export$d31dd875d69daee0 = v);
var $beda4304297005df$export$c0875e83c57c7736;
var $beda4304297005df$export$527776642b333691;
var $beda4304297005df$export$a512452beb4231bf;
var $beda4304297005df$export$6e9351b1ad13c;
var $beda4304297005df$export$d35bc1e505d1ebbf;
var $beda4304297005df$export$d31dd875d69daee0;
$beda4304297005df$export$c0875e83c57c7736 = "spectrum-HelpText_f395de";
$beda4304297005df$export$527776642b333691 = "spectrum-HelpText-validationIcon_f395de";
$beda4304297005df$export$a512452beb4231bf = "spectrum-HelpText-text_f395de";
$beda4304297005df$export$6e9351b1ad13c = "spectrum-HelpText--neutral_f395de";
$beda4304297005df$export$d35bc1e505d1ebbf = "is-disabled_f395de";
$beda4304297005df$export$d31dd875d69daee0 = "spectrum-HelpText--negative_f395de";


function $8e50676506611310$var$HelpText(props, ref) {
    let { description: description , errorMessage: errorMessage , validationState: validationState , isDisabled: isDisabled , showErrorIcon: showErrorIcon , descriptionProps: descriptionProps , errorMessageProps: errorMessageProps  } = props;
    let domRef = $6WzO6$useDOMRef(ref);
    let isErrorMessage = errorMessage && validationState === 'invalid';
    let { styleProps: styleProps  } = $6WzO6$useStyleProps(props);
    return(/*#__PURE__*/ $6WzO6$react.createElement("div", {
        ...styleProps,
        className: $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports)), 'spectrum-HelpText', `spectrum-HelpText--${isErrorMessage ? 'negative' : 'neutral'}`, {
            'is-disabled': isDisabled
        }, styleProps.className),
        ref: domRef
    }, isErrorMessage ? /*#__PURE__*/ $6WzO6$react.createElement($6WzO6$react.Fragment, null, showErrorIcon && /*#__PURE__*/ $6WzO6$react.createElement($6WzO6$spectrumiconsuiAlertMedium, {
        UNSAFE_className: $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports)), 'spectrum-HelpText-validationIcon')
    }), /*#__PURE__*/ $6WzO6$react.createElement("div", {
        ...errorMessageProps,
        className: $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports)), 'spectrum-HelpText-text')
    }, errorMessage)) : /*#__PURE__*/ $6WzO6$react.createElement("div", {
        ...descriptionProps,
        className: $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($beda4304297005df$exports)), 'spectrum-HelpText-text')
    }, description)));
}
/**
 * Help text provides either an informative description or an error message that gives more context about what a user needs to input. It's commonly used in forms.
 */ const $8e50676506611310$export$a67c0bc59081311a = /*#__PURE__*/ $6WzO6$react.forwardRef($8e50676506611310$var$HelpText);





var $79b4ff1b6ea94ffc$exports = {};
var $dfe96401c0c81db3$exports = {};
$dfe96401c0c81db3$exports = {
    "(optional)": `(اختياري)`,
    "(required)": `(مطلوب)`
};


var $f504605657ece833$exports = {};
$f504605657ece833$exports = {
    "(optional)": `(незадължително)`,
    "(required)": `(задължително)`
};


var $ed0ab9e7c53f9351$exports = {};
$ed0ab9e7c53f9351$exports = {
    "(optional)": `(volitelně)`,
    "(required)": `(požadováno)`
};


var $59d9df99e04ee555$exports = {};
$59d9df99e04ee555$exports = {
    "(optional)": `(valgfrit)`,
    "(required)": `(obligatorisk)`
};


var $c5df0169c370d169$exports = {};
$c5df0169c370d169$exports = {
    "(optional)": `(optional)`,
    "(required)": `(erforderlich)`
};


var $3c9af509a01a8d08$exports = {};
$3c9af509a01a8d08$exports = {
    "(optional)": `(προαιρετικό)`,
    "(required)": `(απαιτείται)`
};


var $aa36476f91664a08$exports = {};
$aa36476f91664a08$exports = {
    "(required)": `(required)`,
    "(optional)": `(optional)`
};


var $d96f2251ced25e45$exports = {};
$d96f2251ced25e45$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(necesario)`
};


var $16ec4ffbd4b2ca4b$exports = {};
$16ec4ffbd4b2ca4b$exports = {
    "(optional)": `(valikuline)`,
    "(required)": `(nõutav)`
};


var $60f372f660e937e4$exports = {};
$60f372f660e937e4$exports = {
    "(optional)": `(valinnainen)`,
    "(required)": `(pakollinen)`
};


var $d87c5f1e899f6af1$exports = {};
$d87c5f1e899f6af1$exports = {
    "(optional)": `(facultatif)`,
    "(required)": `(requis)`
};


var $6899669fa63c7816$exports = {};
$6899669fa63c7816$exports = {
    "(optional)": `(אופציונלי)`,
    "(required)": `(נדרש)`
};


var $3597d722a30a8081$exports = {};
$3597d722a30a8081$exports = {
    "(optional)": `(opcionalno)`,
    "(required)": `(obvezno)`
};


var $3ef905a2ce0921cb$exports = {};
$3ef905a2ce0921cb$exports = {
    "(optional)": `(opcionális)`,
    "(required)": `(kötelező)`
};


var $e59d2e4af9ff1c28$exports = {};
$e59d2e4af9ff1c28$exports = {
    "(optional)": `(facoltativo)`,
    "(required)": `(obbligatorio)`
};


var $422a7013ab2cb36d$exports = {};
$422a7013ab2cb36d$exports = {
    "(optional)": `（オプション）`,
    "(required)": `（必須）`
};


var $a58a7ab9570c5a18$exports = {};
$a58a7ab9570c5a18$exports = {
    "(optional)": `(선택 사항)`,
    "(required)": `(필수 사항)`
};


var $24e660c5a5be82af$exports = {};
$24e660c5a5be82af$exports = {
    "(optional)": `(pasirenkama)`,
    "(required)": `(privaloma)`
};


var $a222e05de6d8dce8$exports = {};
$a222e05de6d8dce8$exports = {
    "(optional)": `(neobligāti)`,
    "(required)": `(obligāti)`
};


var $524caea23ab94ad7$exports = {};
$524caea23ab94ad7$exports = {
    "(optional)": `(valgfritt)`,
    "(required)": `(obligatorisk)`
};


var $572079ed86210ca9$exports = {};
$572079ed86210ca9$exports = {
    "(optional)": `(optioneel)`,
    "(required)": `(vereist)`
};


var $6a0777ee77a74b18$exports = {};
$6a0777ee77a74b18$exports = {
    "(optional)": `(opcjonalne)`,
    "(required)": `(wymagane)`
};


var $ea0401974d81b469$exports = {};
$ea0401974d81b469$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigatório)`
};


var $701d0854e4f18979$exports = {};
$701d0854e4f18979$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigatório)`
};


var $dd9fccd10d0a4be3$exports = {};
$dd9fccd10d0a4be3$exports = {
    "(optional)": `(opţional)`,
    "(required)": `(obligatoriu)`
};


var $3cd1eab3b0ecc980$exports = {};
$3cd1eab3b0ecc980$exports = {
    "(optional)": `(дополнительно)`,
    "(required)": `(обязательно)`
};


var $d109f3d68ba24ffc$exports = {};
$d109f3d68ba24ffc$exports = {
    "(optional)": `(nepovinné)`,
    "(required)": `(povinné)`
};


var $6382c2117e9fd1b6$exports = {};
$6382c2117e9fd1b6$exports = {
    "(optional)": `(opcijsko)`,
    "(required)": `(obvezno)`
};


var $ba796dd79114e2d4$exports = {};
$ba796dd79114e2d4$exports = {
    "(optional)": `(opciono)`,
    "(required)": `(obavezno)`
};


var $916521e9800ac46c$exports = {};
$916521e9800ac46c$exports = {
    "(optional)": `(valfritt)`,
    "(required)": `(krävs)`
};


var $acd72b88f580fe64$exports = {};
$acd72b88f580fe64$exports = {
    "(optional)": `(isteğe bağlı)`,
    "(required)": `(gerekli)`
};


var $bd065904f1420f31$exports = {};
$bd065904f1420f31$exports = {
    "(optional)": `(необов’язково)`,
    "(required)": `(обов’язково)`
};


var $0128cc194bc107bb$exports = {};
$0128cc194bc107bb$exports = {
    "(optional)": `（可选）`,
    "(required)": `（必填）`
};


var $c57738f6094a3d25$exports = {};
$c57738f6094a3d25$exports = {
    "(optional)": `(選填)`,
    "(required)": `(必填)`
};


$79b4ff1b6ea94ffc$exports = {
    "ar-AE": $dfe96401c0c81db3$exports,
    "bg-BG": $f504605657ece833$exports,
    "cs-CZ": $ed0ab9e7c53f9351$exports,
    "da-DK": $59d9df99e04ee555$exports,
    "de-DE": $c5df0169c370d169$exports,
    "el-GR": $3c9af509a01a8d08$exports,
    "en-US": $aa36476f91664a08$exports,
    "es-ES": $d96f2251ced25e45$exports,
    "et-EE": $16ec4ffbd4b2ca4b$exports,
    "fi-FI": $60f372f660e937e4$exports,
    "fr-FR": $d87c5f1e899f6af1$exports,
    "he-IL": $6899669fa63c7816$exports,
    "hr-HR": $3597d722a30a8081$exports,
    "hu-HU": $3ef905a2ce0921cb$exports,
    "it-IT": $e59d2e4af9ff1c28$exports,
    "ja-JP": $422a7013ab2cb36d$exports,
    "ko-KR": $a58a7ab9570c5a18$exports,
    "lt-LT": $24e660c5a5be82af$exports,
    "lv-LV": $a222e05de6d8dce8$exports,
    "nb-NO": $524caea23ab94ad7$exports,
    "nl-NL": $572079ed86210ca9$exports,
    "pl-PL": $6a0777ee77a74b18$exports,
    "pt-BR": $ea0401974d81b469$exports,
    "pt-PT": $701d0854e4f18979$exports,
    "ro-RO": $dd9fccd10d0a4be3$exports,
    "ru-RU": $3cd1eab3b0ecc980$exports,
    "sk-SK": $d109f3d68ba24ffc$exports,
    "sl-SI": $6382c2117e9fd1b6$exports,
    "sr-SP": $ba796dd79114e2d4$exports,
    "sv-SE": $916521e9800ac46c$exports,
    "tr-TR": $acd72b88f580fe64$exports,
    "uk-UA": $bd065904f1420f31$exports,
    "zh-CN": $0128cc194bc107bb$exports,
    "zh-TW": $c57738f6094a3d25$exports
};



var $cd231e464c886c86$exports = {};

$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel", () => $cd231e464c886c86$export$493d18e796ae054, (v) => $cd231e464c886c86$export$493d18e796ae054 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--positionSide", () => $cd231e464c886c86$export$9e6f19dc21f22f2e, (v) => $cd231e464c886c86$export$9e6f19dc21f22f2e = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel-requiredIcon", () => $cd231e464c886c86$export$7c47642c7d46f3c9, (v) => $cd231e464c886c86$export$7c47642c7d46f3c9 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--alignEnd", () => $cd231e464c886c86$export$885efcc08143a987, (v) => $cd231e464c886c86$export$885efcc08143a987 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field", () => $cd231e464c886c86$export$f6d480ae1e56eba0, (v) => $cd231e464c886c86$export$f6d480ae1e56eba0 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionTop", () => $cd231e464c886c86$export$a4ea780a9064d7f9, (v) => $cd231e464c886c86$export$a4ea780a9064d7f9 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-field", () => $cd231e464c886c86$export$3ab8a3dc7f0563d, (v) => $cd231e464c886c86$export$3ab8a3dc7f0563d = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionSide", () => $cd231e464c886c86$export$2963225c91179589, (v) => $cd231e464c886c86$export$2963225c91179589 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-wrapper", () => $cd231e464c886c86$export$127df0b7290eb8ef, (v) => $cd231e464c886c86$export$127df0b7290eb8ef = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form", () => $cd231e464c886c86$export$94d2bcc94afabd89, (v) => $cd231e464c886c86$export$94d2bcc94afabd89 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionSide", () => $cd231e464c886c86$export$7f44db659563c8f4, (v) => $cd231e464c886c86$export$7f44db659563c8f4 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionTop", () => $cd231e464c886c86$export$11b8bc81fe551057, (v) => $cd231e464c886c86$export$11b8bc81fe551057 = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-StaticField", () => $cd231e464c886c86$export$a8558488b380a41e, (v) => $cd231e464c886c86$export$a8558488b380a41e = v);
$parcel$export($cd231e464c886c86$exports, "spectrum-Form-itemLabel", () => $cd231e464c886c86$export$51ec27881a1e3928, (v) => $cd231e464c886c86$export$51ec27881a1e3928 = v);
$parcel$export($cd231e464c886c86$exports, "is-disabled", () => $cd231e464c886c86$export$d35bc1e505d1ebbf, (v) => $cd231e464c886c86$export$d35bc1e505d1ebbf = v);
var $cd231e464c886c86$export$493d18e796ae054;
var $cd231e464c886c86$export$9e6f19dc21f22f2e;
var $cd231e464c886c86$export$7c47642c7d46f3c9;
var $cd231e464c886c86$export$885efcc08143a987;
var $cd231e464c886c86$export$f6d480ae1e56eba0;
var $cd231e464c886c86$export$a4ea780a9064d7f9;
var $cd231e464c886c86$export$3ab8a3dc7f0563d;
var $cd231e464c886c86$export$2963225c91179589;
var $cd231e464c886c86$export$127df0b7290eb8ef;
var $cd231e464c886c86$export$94d2bcc94afabd89;
var $cd231e464c886c86$export$7f44db659563c8f4;
var $cd231e464c886c86$export$11b8bc81fe551057;
var $cd231e464c886c86$export$a8558488b380a41e;
var $cd231e464c886c86$export$51ec27881a1e3928;
var $cd231e464c886c86$export$d35bc1e505d1ebbf;
$cd231e464c886c86$export$493d18e796ae054 = "spectrum-FieldLabel_d2db1f";
$cd231e464c886c86$export$9e6f19dc21f22f2e = "spectrum-FieldLabel--positionSide_d2db1f";
$cd231e464c886c86$export$7c47642c7d46f3c9 = "spectrum-FieldLabel-requiredIcon_d2db1f";
$cd231e464c886c86$export$885efcc08143a987 = "spectrum-FieldLabel--alignEnd_d2db1f";
$cd231e464c886c86$export$f6d480ae1e56eba0 = "spectrum-Field_d2db1f";
$cd231e464c886c86$export$a4ea780a9064d7f9 = "spectrum-Field--positionTop_d2db1f";
$cd231e464c886c86$export$3ab8a3dc7f0563d = "spectrum-Field-field_d2db1f";
$cd231e464c886c86$export$2963225c91179589 = "spectrum-Field--positionSide_d2db1f";
$cd231e464c886c86$export$127df0b7290eb8ef = "spectrum-Field-wrapper_d2db1f";
$cd231e464c886c86$export$94d2bcc94afabd89 = "spectrum-Form_d2db1f";
$cd231e464c886c86$export$7f44db659563c8f4 = "spectrum-Form--positionSide_d2db1f";
$cd231e464c886c86$export$11b8bc81fe551057 = "spectrum-Form--positionTop_d2db1f";
$cd231e464c886c86$export$a8558488b380a41e = "spectrum-StaticField_d2db1f";
$cd231e464c886c86$export$51ec27881a1e3928 = "spectrum-Form-itemLabel_d2db1f";
$cd231e464c886c86$export$d35bc1e505d1ebbf = "is-disabled_d2db1f";




function $00af9ba397a66f43$var$Label(props, ref) {
    props = $6WzO6$useProviderProps(props);
    let { children: children , labelPosition: labelPosition = 'top' , labelAlign: labelAlign = labelPosition === 'side' ? 'start' : null , isRequired: isRequired , necessityIndicator: necessityIndicator = isRequired != null ? 'icon' : null , includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName = false , htmlFor: htmlFor , for: labelFor , elementType: ElementType = 'label' , onClick: onClick , ...otherProps } = props;
    let domRef = $6WzO6$useDOMRef(ref);
    let { styleProps: styleProps  } = $6WzO6$useStyleProps(otherProps);
    let stringFormatter = $6WzO6$useLocalizedStringFormatter((/*@__PURE__*/$parcel$interopDefault($79b4ff1b6ea94ffc$exports)));
    let necessityLabel = isRequired ? stringFormatter.format('(required)') : stringFormatter.format('(optional)');
    let icon = /*#__PURE__*/ $6WzO6$react.createElement($6WzO6$spectrumiconsuiAsterisk, {
        UNSAFE_className: $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports)), 'spectrum-FieldLabel-requiredIcon'),
        "aria-label": includeNecessityIndicatorInAccessibilityName ? stringFormatter.format('(required)') : undefined
    });
    let labelClassNames = $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports)), 'spectrum-FieldLabel', {
        'spectrum-FieldLabel--positionSide': labelPosition === 'side',
        'spectrum-FieldLabel--alignEnd': labelAlign === 'end'
    }, styleProps.className);
    return(/*#__PURE__*/ $6WzO6$react.createElement(ElementType, {
        ...$6WzO6$filterDOMProps(otherProps),
        ...styleProps,
        onClick: onClick,
        ref: domRef,
        className: labelClassNames,
        htmlFor: ElementType === 'label' ? labelFor || htmlFor : undefined
    }, children, (necessityIndicator === 'label' || necessityIndicator === 'icon' && isRequired) && ' \u200b', necessityIndicator === 'label' && /*#__PURE__*/ $6WzO6$react.createElement("span", {
        "aria-hidden": !includeNecessityIndicatorInAccessibilityName ? isRequired : undefined
    }, necessityLabel), necessityIndicator === 'icon' && isRequired && icon));
}
let $00af9ba397a66f43$export$b04be29aa201d4f5 = /*#__PURE__*/ $6WzO6$react.forwardRef($00af9ba397a66f43$var$Label);






function $b7ca5b4454a2009d$var$Field(props, ref) {
    props = $6WzO6$useFormProps(props);
    let { label: label , labelPosition: labelPosition = 'top' , labelAlign: labelAlign , isRequired: isRequired , necessityIndicator: necessityIndicator , includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName , validationState: validationState , description: description , errorMessage: errorMessage , isDisabled: isDisabled , showErrorIcon: showErrorIcon , children: children , labelProps: labelProps , descriptionProps: // Not every component that uses <Field> supports help text.
    descriptionProps = {
    } , errorMessageProps: errorMessageProps = {
    } , elementType: elementType , wrapperClassName: wrapperClassName , ...otherProps } = props;
    let { styleProps: styleProps  } = $6WzO6$useStyleProps(otherProps);
    let hasHelpText = !!description || errorMessage && validationState === 'invalid';
    let mergedRefs = $b7ca5b4454a2009d$var$useMergeRefs(children.ref, ref);
    if (label || hasHelpText) {
        let labelWrapperClass = $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports)), 'spectrum-Field', {
            'spectrum-Field--positionTop': labelPosition === 'top',
            'spectrum-Field--positionSide': labelPosition === 'side'
        }, styleProps.className, wrapperClassName);
        children = /*#__PURE__*/ $6WzO6$react.cloneElement(children, $6WzO6$mergeProps(children.props, {
            className: $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports)), 'spectrum-Field-field')
        }));
        let renderHelpText = ()=>/*#__PURE__*/ $6WzO6$react.createElement($8e50676506611310$export$a67c0bc59081311a, {
                descriptionProps: descriptionProps,
                errorMessageProps: errorMessageProps,
                description: description,
                errorMessage: errorMessage,
                validationState: validationState,
                isDisabled: isDisabled,
                showErrorIcon: showErrorIcon
            })
        ;
        let renderChildren = ()=>{
            if (labelPosition === 'side') return(/*#__PURE__*/ $6WzO6$react.createElement($6WzO6$Flex, {
                direction: "column",
                UNSAFE_className: $6WzO6$classNames((/*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports)), 'spectrum-Field-wrapper')
            }, children, hasHelpText && renderHelpText()));
            return(/*#__PURE__*/ $6WzO6$react.createElement($6WzO6$react.Fragment, null, children, hasHelpText && renderHelpText()));
        };
        return(/*#__PURE__*/ $6WzO6$react.createElement("div", {
            ...styleProps,
            ref: ref,
            className: labelWrapperClass
        }, label && /*#__PURE__*/ $6WzO6$react.createElement($00af9ba397a66f43$export$b04be29aa201d4f5, {
            ...labelProps,
            labelPosition: labelPosition,
            labelAlign: labelAlign,
            isRequired: isRequired,
            necessityIndicator: necessityIndicator,
            includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName,
            elementType: elementType
        }, label), renderChildren()));
    }
    return(/*#__PURE__*/ $6WzO6$react.cloneElement(children, $6WzO6$mergeProps(children.props, {
        ...styleProps,
        ref: mergedRefs
    })));
}
function $b7ca5b4454a2009d$var$useMergeRefs(...refs) {
    return $6WzO6$useCallback($6WzO6$mergeRefs(...refs), [
        ...refs
    ]);
}
let $b7ca5b4454a2009d$export$a455218a85c89869 = /*#__PURE__*/ $6WzO6$react.forwardRef($b7ca5b4454a2009d$var$Field);






export {$b7ca5b4454a2009d$export$a455218a85c89869 as Field, $00af9ba397a66f43$export$b04be29aa201d4f5 as Label, $8e50676506611310$export$a67c0bc59081311a as HelpText};
//# sourceMappingURL=module.js.map
